// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { IdentitySubscriptions } from '../../../../types/server/modules/identity/subscriptions';

export type * from '../../../../types/server/modules/identity/subscriptions';

export const createSubscriptions = ( requests: Requests ): IdentitySubscriptions => ({
  CustomRoles: ( params, onChange ) => {
          return requests.subscribe( `/custom-roles/:id?`, params, 'CustomRoles', onChange );
          },
  IdentityAuthUserSecurityMe: ( params, onChange ) => {
          return requests.subscribe( `/identity/auth-user-security/me`, params, 'IdentityAuthUserSecurityMe', onChange );
          },
  IdentityAuthUserSecurity: ( params, onChange ) => {
          return requests.subscribe( `/identity/auth-user-security/:userId?`, params, 'IdentityAuthUserSecurity', onChange );
          }
});
